import { render, staticRenderFns } from "./BoardListQnaLayout.vue?vue&type=template&id=aa4ea564&scoped=true&"
import script from "./BoardListQnaLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListQnaLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4ea564",
  null
  
)

export default component.exports